import React, { useContext, useEffect, useState, Suspense } from 'react'
import './Tailwind.css'
import { getCompanyInfoHelper } from './helpers/getCompanyInfoHelper'
import { DataContext } from './context/DataContext'
import { CheckoutSkeleton, Spinner } from '@pinflag/pinflag-ui-kit'
import { resolveMapboxToken } from './helpers/utils'
import { lazyWithRetry } from './helpers/retryImport'

const PinmapProLazy = lazyWithRetry(() => import('./PinmapPro'))

const App = () => {
  const { setUserInfo, setCompanyInfo, isPickup, companyInfo } =
    useContext(DataContext)
  const [app, setApp] = useState(<CheckoutSkeleton isPickup={isPickup} />)
  const isLoaderIframe = new URLSearchParams(document.location.search).get(
    'loaderIframe'
  )
  const SpinnerComponent = (
    <div className="full_width_spinner">
      <Spinner />
    </div>
  )

  useEffect(() => {
    window.addEventListener('message', receiveMessage)
    getCompanyInfoHelper(setUserInfo, setCompanyInfo)
    return () => {
      window.removeEventListener('message', receiveMessage)
    }
  }, [])

  useEffect(() => {
    if (isLoaderIframe) {
      setApp(
        <Suspense fallback={SpinnerComponent}>
            <PinmapProLazy />
        </Suspense>
      )
      window.removeEventListener('message', receiveMessage)
    }
  }, [isLoaderIframe])

  const processCompanyInfo = (companyData) => {
    const processedCompanyData = {
      ...companyData,
      mapboxToken: resolveMapboxToken(companyData.mapboxToken),
      customBillingNames: companyData.customBillingNames ??
        companyData.cmsBillingFieldsCustomNames?.fields,
      billingDocName: companyData.billingDocName ??
        companyData.cmsBillingFieldsCustomNames?.docName,
      activeBillingFields: companyData.activeBillingFields ??
        companyData.cmsActiveBillingFields
    }

    setCompanyInfo((prevState) => ({
      ...prevState,
      ...processedCompanyData
    }))
  }

  const receiveMessage = async (event) => {
    if (event?.data?.type) {
      const { message, origin, type, pinflagApiKey } = event.data

      if (type === 'request-company-info') {
        const currentPinflagApiKey =
          new URLSearchParams(document.location.search).get('token') ||
          process.env.REACT_APP_API_KEY
        if (
          pinflagApiKey === currentPinflagApiKey &&
          companyInfo?.companyName
        ) {
          window.parent.postMessage(
            {
              type: 'response-company-info',
              origin: 'pinflag-shopify-pinmap-pro',
              pinflagApiKey: currentPinflagApiKey,
              message: companyInfo
            },
            '*'
          )
        }
      } else if (type === 'receive-company-info') {
        processCompanyInfo(message)
      } else if (type === 'receive-cart-info') {
        if (message?.companyInfo) {
          processCompanyInfo(message.companyInfo)
        } else {
          getCompanyInfoHelper(setUserInfo, setCompanyInfo)
        }
        setApp(
          <Suspense fallback={SpinnerComponent}>
              <PinmapProLazy cartMessage={message} cartOrigin={origin} />
          </Suspense>
        )
        window.removeEventListener('message', receiveMessage)
      } else if (type === 'is-ready') {
        if (!companyInfo?.companyName) {
          getCompanyInfoHelper(setUserInfo, setCompanyInfo)
        }
      }
    }
  }

  return app
}

export default App
